import { fromJS, Map, OrderedSet } from 'immutable';

import { PARTNER_STATUSES } from 'entities/partners/constants';
import { TypedMap } from 'utils/typed-map';

import {
  APPROVE,
  DENY,
  FETCH_FAILED,
  FETCH_SUCCESS,
  RESPOND_FAILED,
  RESPOND_SUCCESS,
  SET_DISPLAYED_PARTNER_IDS,
  SET_FETCH_PARAMS,
  SET_TOTALS,
  CREATE_PARTNER,
  CREATE_PARTNER_SUCCESS,
  CREATE_PARTNER_FAILED,
} from './types';
import type { PartnerRequestsActions } from './types';

export type FetchParams = {
  pageNum: number;
  limit: number;
  partnerStatus: PARTNER_STATUSES;
  sort: unknown;
  order: 'asc' | 'desc';
  searchTerm?: string;
};

export type Totals = {
  count: number;
};

type MutableState = {
  loading: boolean;
  error: unknown;
  statusUpdating: {};
  fetchParams: FetchParams;
  totals: Totals;
  displayedPartnerIds: OrderedSet<string>;
};

export type PartnerRequestsState = Map<string, any> & TypedMap<MutableState>;

const initialMutableState: MutableState = {
  loading: true,
  error: null,
  statusUpdating: {},
  fetchParams: {
    pageNum: 0,
    limit: 10,
    partnerStatus: PARTNER_STATUSES.pending,
    // @NOTE-AC
    // This is not playing well
    // with the immutable.Map type
    // which already has a `sort` method
    sort: null,
    order: 'asc',
    searchTerm: '',
  },
  totals: {
    count: 0,
  },
  displayedPartnerIds: OrderedSet<string>(),
};

export const initialState: PartnerRequestsState = fromJS(initialMutableState);

export default (
  state: PartnerRequestsState = initialState,
  action: PartnerRequestsActions
): PartnerRequestsState => {
  switch (action.type) {
    case APPROVE:
    case DENY:
      return state.setIn(['statusUpdating', action.id], true) as PartnerRequestsState;

    case RESPOND_SUCCESS:
    case RESPOND_FAILED:
      return state.setIn(['statusUpdating', action.id], false) as PartnerRequestsState;

    case SET_FETCH_PARAMS:
      // eslint-disable-next-line no-case-declarations
      const fetchParams: Map<string, any> & TypedMap<FetchParams> = state.get('fetchParams');
      return state.merge({
        loading: true,
        fetchParams: fetchParams.merge({ pageNum: 0, ...action.params }),
      }) as PartnerRequestsState;

    case SET_TOTALS:
      return state.set('totals', action.totals) as PartnerRequestsState;

    case SET_DISPLAYED_PARTNER_IDS:
      return state.set('displayedPartnerIds', action.partnerIds) as PartnerRequestsState;

    case FETCH_SUCCESS:
    case CREATE_PARTNER_SUCCESS:
      return state.merge({
        loading: false,
        error: null,
      }) as PartnerRequestsState;

    case FETCH_FAILED:
    case CREATE_PARTNER_FAILED:
      return state.merge({
        loading: false,
        error: action.error,
      }) as PartnerRequestsState;

    case CREATE_PARTNER:
      return state.set('loading', true);

    default:
      return state;
  }
};
